import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { useReveal } from "@/hooks/use-reveal";

const HIGHLIGHTS = [
  "Located adjacent to Bally Toll Plaza",
  "Instant 15-minute FASTag activation",
  "Blacklist / Hotlist removal support",
  "Guidance for KYC & vehicle documents",
  "All major banks & NBFCs supported",
  "Delivery coordinated to all 23 WB districts",
];

export default function AboutOverview() {
  const r = useReveal();
  return (
    <section className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={r.ref} className={`${r.className} grid lg:grid-cols-12 gap-10 items-center`}>
          <div className="lg:col-span-6 relative">
            <div className="relative rounded-3xl overflow-hidden border border-[#E2E8F0] shadow-lg">
              <img
                src="https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/hyw4emyv_fastag%20csp%20team.png"
                alt="FASTag CSP Sayeed Anwar Bally team at Bally Toll Plaza"
                loading="lazy"
                className="w-full h-[420px] object-cover"
              />
            </div>
            <div className="hidden md:block absolute -bottom-8 -right-6 bg-[#0057B8] text-white rounded-2xl p-5 shadow-xl w-64">
              <div className="text-xs uppercase tracking-widest text-[#F59E0B] font-semibold">Rated 4.8 ★ · 61 Google Reviews</div>
              <div className="text-sm mt-2 leading-relaxed text-white/90">
                Verified via our official Google Business listing at Bally Toll Plaza.
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">About Us</span>
            <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
              Your neighbourhood <span className="text-[#0057B8]">FASTag partner</span>
            </h2>
            <p className="mt-4 text-[#6B7280] text-base sm:text-lg leading-relaxed">
              Run by <span className="font-semibold text-[#111827]">Sayeed Anwar</span>, FASTag CSP Bally serves motorists, taxi
              operators and fleet managers from a convenient counter next to the Bally Toll Plaza. Our promise is
              simple — instant activation, hassle-free blacklist removal, and friendly in-person guidance.
            </p>

            <ul className="mt-6 grid sm:grid-cols-2 gap-3">
              {HIGHLIGHTS.map((h) => (
                <li key={h} className="flex items-start gap-2 text-[#111827]">
                  <CheckCircle2 className="w-5 h-5 text-[#0E7490] mt-0.5" />
                  <span className="text-sm">{h}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button asChild size="lg" className="bg-[#0057B8] hover:bg-[#003F87] text-white rounded-full btn-brand">
                <Link to="/about">Read More</Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-[#0057B8] text-[#0057B8] hover:bg-[#0057B8] hover:text-white rounded-full btn-brand">
                <Link to="/find-us">Find Us</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
